module.exports = __webpack_public_path__ + "static/chorus-4-332710e0601d01f93d84833194a26a51.png";